"use client";

import { usePathname } from "next/navigation";

import { TooltipProvider } from "@acme/ui/tooltip";

import { CodemodAiTrigger } from "~/app/_components/codemod-ai-trigger";
import { useFeatureFlagBoolean } from "~/hooks/feature-flags/use-feature-flag-boolean";
import { useSession } from "~/utils/auth";
import { CreatePRButton } from "./action-bar/create-pr-button";
import { RunCliButton } from "./action-bar/run-cli-button";
import { SignInButton } from "./action-bar/sign-in-button";

export function ActionBar() {
  const userSession = useSession();

  const isRunCliEnabled = useFeatureFlagBoolean(
    "studio-ast-grep-run-cli-button",
    false,
  );

  const pathname = usePathname();

  return (
    <TooltipProvider delayDuration={10}>
      <div className="flex items-center gap-1">
        {userSession.status === "unauthenticated" && (
          <SignInButton pathname={pathname} />
        )}

        {/* Run CLI Button */}
        {isRunCliEnabled && <RunCliButton />}

        {/* Create PR Button - only for authenticated users */}
        {userSession.status === "authenticated" && isRunCliEnabled && (
          <CreatePRButton />
        )}

        <CodemodAiTrigger />
      </div>
    </TooltipProvider>
  );
}
